import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('asa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Iter 62em — Distinguer les 401 ASA (JWT expiré) des 401 Drive (OAuth
      // Google Drive non connecté). Sinon, cliquer sur "Connecter Drive"
      // ouvre la modale, qui reçoit un 401 Drive, et l'intercepteur croit à
      // tort que la session ASA est morte → déloge Hugo → retour /login.
      const url = err?.config?.url || '';
      const isDriveRoute = /\/drive(\/|$)/.test(url) || /\/library\/v2\/drive(\/|$)/.test(url);
      const isGuestLogin = /\/auth\/guest-login$/.test(url);
      if (!isDriveRoute && !isGuestLogin) {
        localStorage.removeItem('asa_token');
        // Invité : jamais la page de connexion → on repasse par son lien d'accès
        const guest = localStorage.getItem('asa_guest_link');
        const target = guest ? `/guest/${guest}` : '/login';
        if (window.location.pathname !== target) window.location.href = target;
      }
    }
    return Promise.reject(err);
  }
);

export const fileDownloadUrl = (id) => `${API}/library/files/${id}/download`;
